import React from 'react';
import { TrendingUp, Users, DollarSign, Building2 } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { Button } from '../components/ui/button';

const InvestorPage = () => {
    return (
        <Layout>
            <div data-testid="investor-page">
                {/* Hero */}
                <section className="bg-navy text-white py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">Investor Information</h1>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Join us in revolutionizing the hotel industry marketplace
                        </p>
                    </div>
                </section>

                {/* Opportunity */}
                <section className="py-16 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="max-w-3xl mx-auto text-center mb-12">
                            <h2 className="font-heading text-3xl font-bold text-navy mb-4">The Opportunity</h2>
                            <p className="text-gray-600 text-lg">
                                The hotel industry is a $600 billion market with thousands of properties needing 
                                furniture, supplies, staff, and services. Hotel Motel Club is positioned to become 
                                the go-to marketplace for this massive industry.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-4 gap-6">
                            <div className="bg-gray-50 rounded-lg p-6 text-center">
                                <TrendingUp className="w-10 h-10 text-gold mx-auto mb-3" />
                                <div className="font-heading text-3xl font-bold text-navy">$600B</div>
                                <p className="text-gray-600">Market Size</p>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-6 text-center">
                                <Building2 className="w-10 h-10 text-gold mx-auto mb-3" />
                                <div className="font-heading text-3xl font-bold text-navy">58K+</div>
                                <p className="text-gray-600">US Hotels</p>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-6 text-center">
                                <Users className="w-10 h-10 text-gold mx-auto mb-3" />
                                <div className="font-heading text-3xl font-bold text-navy">2M+</div>
                                <p className="text-gray-600">Industry Workers</p>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-6 text-center">
                                <DollarSign className="w-10 h-10 text-gold mx-auto mb-3" />
                                <div className="font-heading text-3xl font-bold text-navy">12%</div>
                                <p className="text-gray-600">Annual Growth</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Business Model */}
                <section className="py-16 bg-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h2 className="font-heading text-3xl font-bold text-navy text-center mb-12">Revenue Streams</h2>
                        <div className="grid md:grid-cols-3 gap-8">
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Annual Memberships</h3>
                                <p className="text-gray-600 mb-4">
                                    $300/year for unlimited listings, priority placement, and premium features.
                                </p>
                                <ul className="text-sm text-gray-500 space-y-2">
                                    <li>• Unlimited ad postings</li>
                                    <li>• 50% off display ads</li>
                                    <li>• Priority support</li>
                                </ul>
                            </div>
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Pay-Per-Ad</h3>
                                <p className="text-gray-600 mb-4">
                                    $10 per listing for non-members, valid for 30 days.
                                </p>
                                <ul className="text-sm text-gray-500 space-y-2">
                                    <li>• Flexible option</li>
                                    <li>• No commitment</li>
                                    <li>• Perfect for occasional users</li>
                                </ul>
                            </div>
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Display Advertising</h3>
                                <p className="text-gray-600 mb-4">
                                    Premium homepage placements starting at $100.
                                </p>
                                <ul className="text-sm text-gray-500 space-y-2">
                                    <li>• Homepage featured spots</li>
                                    <li>• Category sponsorships</li>
                                    <li>• Newsletter placements</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA */}
                <section className="py-16 bg-navy text-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h2 className="font-heading text-3xl font-bold mb-4">Interested in Investing?</h2>
                        <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
                            We're seeking strategic partners who share our vision for transforming the hotel industry marketplace.
                        </p>
                        <a href="/contact">
                            <Button className="bg-gold hover:bg-amber-600">
                                Contact Us
                            </Button>
                        </a>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default InvestorPage;
